import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";

export default class extends Controller {
  static get targets() {
    return ["field"];
  }

  connect() {
    this._initializeModal();
    this.fieldTarget.value = this.defaultTime;
  }

  _initializeModal() {
    if (this.disableModal) {
      return;
    }

    M.Timepicker.init(this.fieldTarget, this.options);
  }

  get defaultTime() {
    return this.element.value;
  }

  get disableModal() {
    return this.fieldTarget.dataset.disableModal === "true";
  }

  get fetchTwelveHour() {
    return this.fieldTarget.dataset.twelveHour === "true";
  }

  get options() {
    return {
      defaultTime: this.defaultTime,
      setDefaultDate: true,
      twelveHour: this.fetchTwelveHour
    };
  }
}
